import { render, staticRenderFns } from "./Forbid .vue?vue&type=template&id=58d036cf&scoped=true&"
import script from "./Forbid .vue?vue&type=script&lang=js&"
export * from "./Forbid .vue?vue&type=script&lang=js&"
import style0 from "./Forbid .vue?vue&type=style&index=0&id=58d036cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d036cf",
  null
  
)

export default component.exports